import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Toast from '../Toaster';
import mode from '../Mode';
import './lipamdogomdogo.css';

// Step 1: Phone Number Verification
const PhoneVerification = ({ ticketId, onVerified, isLoading, setIsLoading }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState('');
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/' : 'http://127.0.0.1:8000/';
    const member = useSelector((state) => state.auth.member);

    const handleVerifyPhone = async (e) => {
        e.preventDefault();
        setError('');

        if (!phoneNumber || phoneNumber.length < 9) {
            setError('Please enter a valid phone number');
            return;
        }

        if (!ticketId) {
            setError('Ticket information missing. Please go back and try again.');
            return;
        }

        setIsLoading(true);
        const updated_num = "+254" + phoneNumber
        //console.log(updated_num)
        const reference = "TCT" + String(ticketId).slice(-2); //reference should be the last two character of the ticket id which is a uuid

        axios.post(baseurl + 'payments/checkout/', {
            phone_number: updated_num,
            amount: 1,
            reference: reference,
            description: reference,
            billref: reference
        }).then((resp) => {
            setIsLoading(false);
            toast.success('M-Pesa prompt sent to your phone. Please complete the payment.');
            //console.log(resp)
            onVerified(phoneNumber, resp.data.verification_code);
        }).catch((err) => {
            setIsLoading(false);
            setError(err.response?.data?.message || 'Failed to send M-Pesa prompt. Please try again.');
            console.error('Payment error:', err);
        })

        // try {
        //     // Send M-Pesa STK push for verification
        //     const response = await axios.post(baseurl + 'tickets/lipa-mdogo/verify-phone/', {
        //         phone_number: phoneNumber,
        //         ticket_price: 1,
        //         member_id: member.member.id
        //     });

        //     if (response.status === 200) {
        //         toast.success('M-Pesa prompt sent to your phone. Please complete the payment.');
        //         onVerified(phoneNumber, response.data.verification_code);
        //     }
        // } catch (err) {
        //     setError(err.response?.data?.message || 'Failed to send M-Pesa prompt. Please try again.');
        //     console.error('Phone verification error:', err);
        // }
    };

    return (
        <div className="lpmd-step-container">
            <div className="lpmd-step-header">
                <h2>Step 1: Verify Your Phone Number</h2>
                <p>Enter the phone number you use for M-Pesa payments</p>
            </div>

            <form onSubmit={handleVerifyPhone} className="lpmd-form">
                <div className="lpmd-form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <div className="lpmd-phone-input-wrapper">
                        <span className="lpmd-country-code">+254</span>
                        <input
                            type="tel"
                            id="phone"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            placeholder="712345678"
                            maxLength="9"
                            disabled={isLoading}
                            className="lpmd-phone-input"
                        />
                    </div>
                    {error && <div className="lpmd-error">{error}</div>}
                </div>

                <div className="lpmd-info-box">
                    {/* <p><strong>Ticket Price:</strong> KSh {ticketPrice?.toLocaleString()}</p> */}
                    <p className="lpmd-info-text">You'll receive an M-Pesa prompt on your phone. Complete the payment with any amount to verify your number.</p>
                </div>

                <button 
                    type="submit" 
                    className="lpmd-btn lpmd-btn-primary"
                    disabled={isLoading}
                >
                    {isLoading ? 'Sending prompt...' : 'Send M-Pesa Prompt'}
                </button>
            </form>
        </div>
    );
};

// Step 2: Code Verification
const CodeVerification = ({ phoneNumber, verificationCode, onCodeVerified, isLoading, onBack, ticket_id, setIsLoading }) => {
    const [enteredCode, setEnteredCode] = useState('');
    const [error, setError] = useState('');
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/' : 'http://127.0.0.1:8000/';
    const member = useSelector((state) => state.auth.member);

    const handleVerifyCode = async (e) => {
        e.preventDefault();
        setError('');

        if (!enteredCode) {
            setError('Please enter the code from your M-Pesa message');
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.post(baseurl + 'tickets/lipa-mdogo/verify-code', {
                code: enteredCode,
                phone_number: phoneNumber,
                ticket_id: ticket_id
            });

            //console.log(response.data)

            if (response.status === 200) {
                setIsLoading(false);
                toast.success('Phone number verified successfully!');
                onCodeVerified(response.data);
            }
        } catch (err) {
            setIsLoading(false);
            setError(err.response?.data?.message || 'Invalid code. Please try again.');
            console.error('Code verification error:', err);
        }
    };

    return (
        <div className="lpmd-step-container">
            <div className="lpmd-step-header">
                <h2>Step 2: Verify Code</h2>
                <p>Enter the 5-digit code on the account section of the Mpesa message. (Expires in 5mins)</p>
            </div>

            <div className="lpmd-phone-display">
                <p>Phone: <strong>+254{phoneNumber}</strong></p>
            </div>

            <form onSubmit={handleVerifyCode} className="lpmd-form">
                <div className="lpmd-form-group">
                    <label htmlFor="code">Verification Code</label>
                    <input
                        type="text"
                        id="code"
                        value={enteredCode}
                        onChange={(e) => setEnteredCode(e.target.value.toUpperCase())}
                        placeholder="Enter 5-digit code"
                        maxLength="5"
                        disabled={isLoading}
                        className="lpmd-code-input"
                    />
                    {error && <div className="lpmd-error">{error}</div>}
                </div>

                <div className="lpmd-form-actions">
                    <button 
                        type="button"
                        className="lpmd-btn lpmd-btn-secondary"
                        onClick={onBack}
                        disabled={isLoading}
                    >
                        Back
                    </button>
                    <button 
                        type="submit" 
                        className="lpmd-btn lpmd-btn-primary"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Verifying...' : 'Verify'}
                    </button>
                </div>
            </form>
        </div>
    );
};

// Step 3: Payment Summary & Additional Payments
const PaymentSummary = ({ 
    ticketId, 
    phoneNumber, 
    transactions, 
    totalPaid,
    usableAmount,
    onPayMore,
    onRefreshTransactions,
    onGetTicket,
    isLoading,
    setIsLoading,
    ticketOptions = []
}) => {
    const [paymentAmount, setPaymentAmount] = useState('');
    const [error, setError] = useState('');
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/' : 'http://127.0.0.1:8000/';
    const member = useSelector((state) => state.auth.member);

    // Get the highest priced option the user can afford
    const getPurchasableOptions = () => {
        return ticketOptions.filter(option => usableAmount >= option.price);
    };

    // Get the next affordable option
    const getNextAffordableOption = () => {
        return ticketOptions
            .filter(option => usableAmount < option.price)
            .sort((a, b) => a.price - b.price)[0];
    };

    const purchasableOptions = getPurchasableOptions();
    const nextOption = getNextAffordableOption();
    const spentAmount = Math.max(totalPaid - usableAmount, 0);

    const handlePayMore = async (e) => {
        e.preventDefault();
        setError('');

        const amount = parseFloat(paymentAmount);
        if (!paymentAmount || amount <= 0) {
            setError('Please enter a valid amount');
            return;
        }

        setIsLoading(true);
        const updated_num = "+254" + phoneNumber
        //console.log(updated_num)
        const reference = "TCT" + String(ticketId).slice(-2); //reference should be the last two character of the ticket id which is a uuid

        axios.post(baseurl + 'payments/checkout/', {
            phone_number: updated_num,
            amount: amount,
            reference: reference,
            description: reference,
            billref: reference
        }).then((resp) => {
            setIsLoading(false);
            toast.success('M-Pesa prompt sent. Please complete the payment.');
            setPaymentAmount('');
            onPayMore();
        }).catch((err) => {
            setIsLoading(false);
            const errorMessage = err.response?.data?.message || 'Failed to process payment. Please try again.';
            setError(errorMessage);
            toast.error(errorMessage);
        })
    };

    return (
        <div className="lpmd-step-container">
            <div className="lpmd-step-header">
                <h2>Step 3: Payment Summary & Ticket Options</h2>
                <p>View your payment and select a ticket option</p>
            </div>

            {/* Summary Cards */}
            <div className="lpmd-summary-cards">
                <div className="lpmd-card lpmd-card-total">
                    <span className="lpmd-card-label">Total Paid</span>
                    <span className="lpmd-card-value">KSh {totalPaid.toLocaleString()}</span>
                </div>
                <div className="lpmd-card lpmd-card-usable">
                    <span className="lpmd-card-label">Usable Amount</span>
                    <span className="lpmd-card-value">KSh {usableAmount.toLocaleString()}</span>
                </div>
                <div className="lpmd-card lpmd-card-spent">
                    <span className="lpmd-card-label">Spent Amount</span>
                    <span className="lpmd-card-value">KSh {spentAmount.toLocaleString()}</span>
                </div>
            </div>

            {/* Transactions Table */}
            {transactions && transactions.length > 0 && (
                <div className="lpmd-transactions-section">
                    <div className="lpmd-transactions-header">
                        <h3>Transaction History</h3>
                        <button
                            type="button"
                            className="lpmd-refresh-btn"
                            onClick={onRefreshTransactions}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Refreshing...' : 'Refresh'}
                        </button>
                    </div>
                    <div className="lpmd-table-wrapper">
                        <table className="lpmd-transactions-table">
                            <thead>
                                <tr>
                                    <th>Date Time</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Reference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map((transaction, index) => (
                                    <tr key={index}>
                                        <td>{new Date(transaction.created).toLocaleString()}</td>
                                        <td>KSh {transaction.amount.toLocaleString()}</td>
                                        <td>
                                            <span className={`lpmd-status lpmd-status-${transaction.status}`}>
                                                {transaction.status === '0' || transaction.status === 0 ? 'Complete' : transaction.status}
                                            </span>
                                        </td>
                                        <td className="lpmd-reference">{transaction.reference || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Ticket Options Section */}
            <div className="lpmd-options-section">
                <h3>Available Ticket Options</h3>
                
                {/* Purchasable Options */}
                {purchasableOptions.length > 0 && (
                    <div className="lpmd-purchasable-options">
                        <h4>You Can Get These Tickets</h4>
                        {purchasableOptions.map((option) => (
                            <div key={option.id} className="lpmd-option-card lpmd-option-available">
                                <div className="lpmd-option-header">
                                    <h5>{option.name}</h5>
                                    <span className="lpmd-option-price">KSh {option.price.toLocaleString()}</span>
                                </div>
                                <div className="lpmd-progress-container">
                                    <div className="lpmd-progress-bar">
                                        <div 
                                            className="lpmd-progress-fill lpmd-progress-complete" 
                                            style={{ width: '100%' }}
                                        ></div>
                                    </div>
                                    <p className="lpmd-progress-text">100% Paid</p>
                                </div>
                                <button 
                                    type="button"
                                    className="lpmd-btn lpmd-btn-success"
                                    onClick={() => onGetTicket(option.id)}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Processing...' : `Get ${option.name} Ticket`}
                                </button>
                            </div>
                        ))}
                    </div>
                )}

                {/* Next Affordable Option */}
                {nextOption && (
                    <div className="lpmd-next-options">
                        <h4>Next Ticket Available</h4>
                        <div className="lpmd-option-card lpmd-option-upcoming">
                            <div className="lpmd-option-header">
                                <h5>{nextOption.name}</h5>
                                <span className="lpmd-option-price">KSh {nextOption.price.toLocaleString()}</span>
                            </div>
                            <div className="lpmd-progress-container">
                                <div className="lpmd-progress-bar">
                                    <div 
                                        className="lpmd-progress-fill" 
                                        style={{ width: `${(usableAmount / nextOption.price) * 100}%` }}
                                    ></div>
                                </div>
                                <p className="lpmd-progress-text">{Math.round((usableAmount / nextOption.price) * 100)}% Complete ({usableAmount.toLocaleString()} of {nextOption.price.toLocaleString()})</p>
                            </div>
                            <p className="lpmd-remaining-amount">
                                You need KSh <strong>{(nextOption.price - usableAmount).toLocaleString()}</strong> more
                            </p>
                        </div>
                    </div>
                )}

                {/* Other Options */}
                {ticketOptions.length > purchasableOptions.length + (nextOption ? 1 : 0) && (
                    <div className="lpmd-other-options">
                        <h4>Other Options</h4>
                        {ticketOptions
                            .filter(opt => !purchasableOptions.some(p => p.id === opt.id) && (!nextOption || opt.id !== nextOption.id))
                            .map((option) => (
                                <div key={option.id} className="lpmd-option-card lpmd-option-locked">
                                    <div className="lpmd-option-header">
                                        <h5>{option.name}</h5>
                                        <span className="lpmd-option-price">KSh {option.price.toLocaleString()}</span>
                                    </div>
                                    <p className="lpmd-locked-message">
                                        🔒 You need KSh {(option.price - usableAmount).toLocaleString()} more
                                    </p>
                                </div>
                            ))}
                    </div>
                )}
            </div>

            {/* Pay More Section */}
            {(!purchasableOptions.length || nextOption) && (
                <form onSubmit={handlePayMore} className="lpmd-form lpmd-form-payment">
                    <h3>Pay More to Unlock Tickets</h3>
                    <div className="lpmd-form-group">
                        <label htmlFor="amount">Amount (KSh)</label>
                        <input
                            type="number"
                            id="amount"
                            value={paymentAmount}
                            onChange={(e) => setPaymentAmount(e.target.value)}
                            placeholder="Enter amount"
                            min="1"
                            step="0.01"
                            disabled={isLoading}
                            className="lpmd-amount-input"
                        />
                        {error && <div className="lpmd-error">{error}</div>}
                    </div>

                    <button 
                        type="submit" 
                        className="lpmd-btn lpmd-btn-primary"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Processing...' : 'Send M-Pesa Prompt'}
                    </button>
                </form>
            )}
        </div>
    );
};

// Step 4: Buyer Details & Ticket Delivery
const GetTicketEmail = ({ selectedOptionId, selectedOptionName, onSubmit, isLoading, onBack, setIsLoading }) => {
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!firstName.trim()) {
            setError('Please enter first name');
            return;
        }

        if (!lastName.trim()) {
            setError('Please enter last name');
            return;
        }

        if (!phoneNumber.trim()) {
            setError('Please enter phone number');
            return;
        }

        const phoneDigits = phoneNumber.replace(/\D/g, '');
        if (phoneDigits.length < 9) {
            setError('Phone number must have at least 9 digits');
            return;
        }
        const lastNineDigits = phoneDigits.slice(-9);

        if (!email || !email.includes('@')) {
            setError('Please enter a valid email address');
            return;
        }

        const confirmed = window.confirm(
            `Confirm ticket details:\n\n` +
            `Name: ${firstName.trim()} ${middleName.trim()} ${lastName.trim()}\n` +
            `Phone: ${phoneNumber.trim()}\n` +
            `Email: ${email.trim()}\n` +
            `Ticket: ${selectedOptionName}`
        );

        if (!confirmed) {
            return;
        }

        setIsLoading(true);
        onSubmit({
            first_name: firstName.trim(),
            middle_name: middleName.trim(),
            last_name: lastName.trim(),
            phone_number: lastNineDigits,
            email: email.trim(),
            ticket_option: selectedOptionId
        });
    };

    return (
        <div className="lpmd-step-container">
            <div className="lpmd-step-header">
                <h2>Step 4: Get Your Ticket</h2>
                <p>Enter details for your <strong>{selectedOptionName}</strong> ticket</p>
            </div>

            <form onSubmit={handleSubmit} className="lpmd-form">
                <div className="lpmd-form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input
                        type="text"
                        id="firstName"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        placeholder="First name"
                        disabled={isLoading}
                        className="lpmd-email-input"
                    />
                </div>

                <div className="lpmd-form-group">
                    <label htmlFor="middleName">Middle Name (Optional)</label>
                    <input
                        type="text"
                        id="middleName"
                        value={middleName}
                        onChange={(e) => setMiddleName(e.target.value)}
                        placeholder="Middle name"
                        disabled={isLoading}
                        className="lpmd-email-input"
                    />
                </div>

                <div className="lpmd-form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input
                        type="text"
                        id="lastName"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        placeholder="Last name"
                        disabled={isLoading}
                        className="lpmd-email-input"
                    />
                </div>

                <div className="lpmd-form-group">
                    <label htmlFor="ticketPhone">Phone Number</label>
                    <input
                        type="text"
                        id="ticketPhone"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="e.g. 254712345678"
                        disabled={isLoading}
                        className="lpmd-email-input"
                    />
                </div>

                <div className="lpmd-form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="your.email@example.com"
                        disabled={isLoading}
                        className="lpmd-email-input"
                    />
                </div>

                {error && <div className="lpmd-error">{error}</div>}

                <div className="lpmd-info-box">
                    <p>Your <strong>{selectedOptionName}</strong> ticket will be sent to this email address. Make sure it's correct!</p>
                </div>

                <div className="lpmd-form-actions">
                    <button 
                        type="button"
                        className="lpmd-btn lpmd-btn-secondary"
                        onClick={onBack}
                        disabled={isLoading}
                    >
                        Back
                    </button>
                    <button 
                        type="submit" 
                        className="lpmd-btn lpmd-btn-primary"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Submitting...' : 'Confirm & Buy Ticket'}
                    </button>
                </div>
            </form>
        </div>
    );
};

// Main Component
const LipaMdogoMdogo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const member = useSelector((state) => state.auth.member);
    const baseurl = mode ? 'https://backend.portal.jkusdachurch.org/' : 'http://127.0.0.1:8000/';

    const [currentStep, setCurrentStep] = useState(() => {
        // Load from sessionStorage if available
        const saved = sessionStorage.getItem('lpmd_currentStep');
        return saved ? parseInt(saved) : 1;
    });
    const [isLoading, setIsLoading] = useState(false);
    const [ticketData, setTicketData] = useState(() => {
        // Load from sessionStorage if available
        const saved = sessionStorage.getItem('lpmd_ticketData');
        return saved ? JSON.parse(saved) : null;
    });
    const [phoneNumber, setPhoneNumber] = useState(() => {
        return sessionStorage.getItem('lpmd_phoneNumber') || '';
    });
    const [verificationCode, setVerificationCode] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [totalPaid, setTotalPaid] = useState(0);
    const [usableAmount, setUsableAmount] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);

    // Save currentStep to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('lpmd_currentStep', currentStep.toString());
    }, [currentStep]);

    // Save phoneNumber to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('lpmd_phoneNumber', phoneNumber);
    }, [phoneNumber]);

    // Save ticketData to sessionStorage whenever it changes
    useEffect(() => {
        if (ticketData) {
            sessionStorage.setItem('lpmd_ticketData', JSON.stringify(ticketData));
        }
    }, [ticketData]);

    // Get ticket data from navigation state
    useEffect(() => {
        if (location.state?.ticket) {
            setTicketData(location.state.ticket);
            //console.log('Ticket Data:', location.state.ticket);
        } else {
            // Fallback: redirect to tickets page if no ticket data
            navigate('/tickets');
        }
    }, [location, navigate]);

    // Fetch transactions when component mounts if phoneNumber exists (page reload scenario)
    useEffect(() => {
        if (phoneNumber && currentStep >= 2 && currentStep <= 4 && ticketData) {
            fetchTransactions();
        }
    }, []); // Run only once on mount

    // Cleanup sessionStorage when component unmounts or user navigates away
    useEffect(() => {
        const handleBeforeUnload = () => {
            // Only clear if we've completed the flow (step 4 with success)
            // Otherwise, preserve the state for page reloads
        };

        return () => {
            // Don't clear on unmount - let the user resume their flow
        };
    }, []);

    const handlePhoneVerified = (phone, code) => {
        setPhoneNumber(phone);
        setVerificationCode(code);
        setCurrentStep(2);
    };

    const handleCodeVerified = (data) => {
        setTransactions(data.transactions || []);
        setTotalPaid(data.total_amount || 0);
        setUsableAmount(data.usable_amount || 0);
        setCurrentStep(3);
    };

    const handlePayMore = () => {
        // Fetch updated transactions
        fetchTransactions();
    };

    const fetchTransactions = async () => {
        try {
            const response = await axios.get(
                baseurl + `tickets/lipa-mdogo/transactions`,
                {
                    params: { phone_number: phoneNumber, ticket_id: ticketData.ticket_id }
                }
            );

            //console.log(response.data)
            setTransactions(response.data.transactions || []);
            setTotalPaid(response.data.total_amount || 0);
            setUsableAmount(response.data.usable_amount || 0);
        } catch (err) {
            console.error('Failed to fetch transactions:', err);
        }
    };

    const handleGetTicket = (optionId) => {
        // Find the selected option
        //toast.info("Coming Soon! This feature is under development.");
        const option = ticketData.options.find(opt => opt.id === optionId);
        if (option) {
            setSelectedOption(option);
            setCurrentStep(4);
        } else {
            toast.error('Selected ticket option not found. Please try again.');
        }
    };

    const handleSendTicket = async (ticketDetails) => {
        setIsLoading(true);
        try {
            const response = await axios.post(baseurl + 'tickets/lipa-mdogo/buy-ticket', ticketDetails);

            if (response.status === 200) {
                toast.success(response.data?.message || 'Ticket purchase completed successfully!');
                await fetchTransactions();
                setSelectedOption(null);
                setCurrentStep(3);
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Ticket purchase failed. Please try again.');
            console.error('Buy ticket error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    if (!ticketData) {
        return <div className="lpmd-loading">Loading...</div>;
    }

    return (
        <div className="lpmd-container">
            <Toast />
            <div className="lpmd-wrapper">
                {/* Steps Indicator */}
                <div className="lpmd-steps">
                    <div className={`lpmd-step-indicator ${currentStep >= 1 ? 'active' : ''}`}>
                        <span>1</span>
                        <p>Phone</p>
                    </div>
                    <div className={`lpmd-step-indicator ${currentStep >= 2 ? 'active' : ''}`}>
                        <span>2</span>
                        <p>Verify</p>
                    </div>
                    <div className={`lpmd-step-indicator ${currentStep >= 3 ? 'active' : ''}`}>
                        <span>3</span>
                        <p>Summary</p>
                    </div>
                    <div className={`lpmd-step-indicator ${currentStep >= 4 ? 'active' : ''}`}>
                        <span>4</span>
                        <p>Ticket</p>
                    </div>
                </div>

                {/* Ticket Header */}
                <div className="lpmd-ticket-header">
                    <h1>{ticketData.name}</h1>
                    <p className="lpmd-ticket-description">{ticketData.description}</p>
                </div>

                {/* Step Content */}
                <div className="lpmd-content">
                    {currentStep === 1 && (
                        <PhoneVerification 
                            ticketId={ticketData.ticket_id}
                            onVerified={handlePhoneVerified}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                        />
                    )}
                    {currentStep === 2 && (
                        <CodeVerification 
                            phoneNumber={phoneNumber}
                            verificationCode={verificationCode}
                            onCodeVerified={handleCodeVerified}
                            isLoading={isLoading}
                            onBack={() => setCurrentStep(1)}
                            ticket_id={ticketData.ticket_id}
                            setIsLoading={setIsLoading}
                        />
                    )}
                    {currentStep === 3 && (
                        <PaymentSummary 
                            ticketId={ticketData.ticket_id}
                            phoneNumber={phoneNumber}
                            transactions={transactions}
                            totalPaid={totalPaid}
                            usableAmount={usableAmount}
                            onPayMore={handlePayMore}
                            onRefreshTransactions={fetchTransactions}
                            onGetTicket={handleGetTicket}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            ticketOptions={ticketData.options || []}
                        />
                    )}
                    {currentStep === 4 && selectedOption && (
                        <GetTicketEmail 
                            selectedOptionId={selectedOption.id}
                            selectedOptionName={selectedOption.name}
                            onSubmit={handleSendTicket}
                            isLoading={isLoading}
                            onBack={() => setCurrentStep(3)}
                            setIsLoading={setIsLoading}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LipaMdogoMdogo;
